export default __webpack_public_path__ + "static/media/Paul-Nixon.74fb4bb2.png";